module.exports = __webpack_public_path__ + "static/media/one_collecting_wave@2x.24a0d026.png";